import { BankableTypeEnum, OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { List, ListItem } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { EntityFunding } from './EntityFunding'

type OrganizationFundingProps = {
  org: OrganizationDetailFragment
  readonly?: boolean
}
export const OrganizationFunding = ({ org, readonly }: OrganizationFundingProps) => {
  return (
    <List>
      <ListItem disableGutters disablePadding>
        <EntityFunding entity={{ type: BankableTypeEnum.Org, ...org }} readonly={readonly} />
      </ListItem>
    </List>
  )
}
